<template>
  <div style="
  height: calc(100vh - 55px);
width: 100%;
    display: block;
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: normal;">
    <b-row style="border-bottom: 2px solid #c2c2c2">
      <b-col sm="12">
        <div class="margin-neg">
          <b-row>
            <b-col sm="2">
              <b-form-group
                  label="Abfrageart"
              >
                <b-form-select
                               :options="queryTypeSelects"
                               v-model="queryType"
                               size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col md="3" lg="3" xl="2" v-if="queryType === 'S' || queryType === 'K'" >
              <b-row>
                <b-col md="6" v-if="queryType === 'S' || queryType === 'K'" style="padding: 0px">
                  <span>Leistung von</span>
                  <b-row style="margin-left: 0px; margin-right: 0px">
                    <b-checkbox style="margin-top: 0.6rem" v-model="hasFrom"></b-checkbox>
                    <datetime
                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem; width: 65%;"
                        v-model="from"
                        input-class="form-control form-control-sm"
                        input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                        input-id="date1"
                        :phrases="datetimeConfig.phrases"
                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                        size="sm"
                    ></datetime>
                  </b-row>
                </b-col>
                <b-col md="6" v-if="queryType === 'S' || queryType === 'K'" style="padding: 0px">
                  <span>Leistung bis</span>
                  <b-row style="margin-left: 0px; margin-right: 0px">
                    <b-checkbox style="margin-top: 0.6rem" v-model="hasTill"></b-checkbox>
                    <datetime
                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem; width: 65%;"
                        v-model="till"
                        input-class="form-control form-control-sm"
                        input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                        input-id="date"
                        :phrases="datetimeConfig.phrases"
                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                        size="sm"
                    ></datetime>
                  </b-row>

                </b-col>
              </b-row>
            </b-col>
            <b-col md="3" lg="3" xl="2" v-if="queryType === 'SM' || queryType === 'KM'">
              <b-row>
                <span>Monat</span>
              </b-row>
              <b-row>
                <ch-left
                    @click="move(-1)"
                    style="margin-top: 0.5rem; margin-right: 0.5rem;"
                    title=""
                    v-tooltip="'Zurück'"
                    :class="'icon-1_5x no-select ic-chevron'"  :size="72"></ch-left>

                <month-picker-input
                    key="month-picker"
                    lang="de"
                    :default-month="defaultMonth"
                    :default-year="defaultYear"
                    input-pre-filled
                    @input="monthPickerChanged"
                ></month-picker-input>
                <ch-right
                    @click="move(1)"
                    style="margin-top: 0.5rem; margin-left: 0.5rem;"
                    title=""
                    v-tooltip="'Vor'"
                    :class="'icon-1_5x no-select ic-chevron'" :size="72"></ch-right>

              </b-row>
            </b-col>
            <b-col sm="2" v-if="queryType === 'S' || queryType === 'SM'" style="padding-left: 0px">
              <b-form-group
                  label="Einzelaufträge"
              >
                <b-form-select
                    :options="einzelSelects"
                    v-model="includeEinzel"
                    size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col sm="2" v-if="(queryType === 'K' || queryType === 'KM') && useHh" style="padding-left: 0px">
              <b-form-group
                  label="Einnahmekonto"
              >
                <b-form-select
                    :options="hhs"
                    v-model="selectedHh"
                    text-field="name"
                    value-field="account"
                    size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col class="flex-row-reverse" style="display: flex">
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px" @click="openPreview" :disabled="selected.positions.length === 0 && selectedTasks.length === 0">
                <eur-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></eur-icon>Rechnung ausgeben
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row style="height: calc(100% - 89px)">
      <b-col md="3" style="height: 100%; padding-right: 0px">
        <tree
              filterPlaceholder="Suchen" filterBy="label" selectionMode="multiple" @node-select="selectionChanged"
              @node-unselect="selectionChanged" :selectionKeys.sync="selectedKey" :expandedKeys.sync="expandedKeys" :filter="false"
              filterMode="lenient" :value="treeNodes" style="height: 100%; overflow: auto; border: none; border-right: 2px solid #c2c2c2"
              :class="{'shift-left': queryType === 'K' || queryType === 'KM'}"
        ></tree>
      </b-col>
      <b-col md="9" style="height: 100%; overflow: auto; padding-left: 0px;">
        <b-table striped bordered hover responsive id="my-table" :items="selectedTasks"
                 tbody-tr-class="test"
                 :fields="taskFields"
                  v-if="selectedTasks.length && queryType !== 'K' && queryType !== 'KM'">
          <template v-slot:cell(icon)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red"></book-open-page-variant-icon>
          </template>
        </b-table>
        <b-table striped bordered hover responsive id="my-table2" :items="selectedTasks"
                 tbody-tr-class="test"
                 :fields="kontoFields"
                 v-else-if="selectedTasks.length">
          <template v-slot:cell(icon)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <wallet-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red"></wallet-icon>
          </template>
        </b-table>
        <b-row v-if="!selectedTasks.length" style="padding: 1rem; border: 1px solid #c2c2c2">
          <b-col md="1" style="padding-right: 0px" v-if="selected.id && queryType !== 'K' && queryType !== 'KM'">
            <b>{{selected.id}}</b>
          </b-col>
          <b-col md="4" v-if="selected.id">
            <b>{{queryType !== 'K' && queryType !== 'KM' ? (selected.object + ", " + selected.auf_name) : (selected.hh_aus_txt + ' - ' + selected.hh_ein_txt)}}</b>
          </b-col>
          <b-col></b-col>
          <b-col md="3" style="border: 1px solid black">
            <b-row>
              <b-col><b>Gesamtpreis:</b></b-col>
              <b-col class="text-right"><b>{{getGesPreis()}}</b></b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-table striped bordered hover id="my-table-2" :items="selected.positions"
                 tbody-tr-class="test"
                 :fields="positionFields"
                 v-if="!selectedTasks.length"
        style="overflow: scroll">
          <template v-slot:cell(gi_legr)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <account-clock-icon v-if="row.item.gi_legr === 'ARBL'" class="icon-1_5x" fillColor="#0022ff" :size="72" style="color:#0022ff"></account-clock-icon>
            <car-icon v-else-if="row.item.gi_legr === 'FAGE'" class="icon-1_5x" fillColor="#016d03" :size="72" style="color:#016d03"></car-icon>
            <wall-icon v-else-if="row.item.gi_legr === 'EIMA'" class="icon-1_5x" fillColor="#b20720" :size="72" style="color:#b20720"></wall-icon>
            <wall-icon v-else class="icon-1_5x" fillColor="#2c2525" :size="72" style="color:#2c2525"></wall-icon>
          </template>
        </b-table>
      </b-col>

    </b-row>
    <calculation-overlay ref="calculationOverlay" :hide-loader="hideLoader" :show-loader="showLoader" @close="queryData()"></calculation-overlay>
  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import EurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import TaskFilterModal from "@/views/aufgaben_verwaltung/TaskFilterModal.vue";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import WalletIcon from 'vue-material-design-icons/Wallet.vue';
import AccountClockIcon from 'vue-material-design-icons/AccountClock.vue';
import CarIcon from 'vue-material-design-icons/Car.vue';
import WallIcon from 'vue-material-design-icons/Wall.vue';
import MaterialIcon from 'vue-material-design-icons/PaletteSwatch.vue';
import ChLeft from 'vue-material-design-icons/ChevronLeft';
import ChRight from 'vue-material-design-icons/ChevronRight';
import { MonthPickerInput } from 'vue-month-picker'
import CalculationOverlay from "@/views/calculation/calculation_overlay.vue";

import Tree from '../custom/TaskTree.vue';
import {base64ToArrayBuffer, decryptPositions} from "@/shared/crypto";

export default {
  name: "calculation",
  components:
      {
        EurIcon,
        'tree': Tree,
        BookOpenPageVariantIcon,
        AccountClockIcon,
        CarIcon,
        WallIcon,
        MaterialIcon,
        MonthPickerInput, ChLeft, ChRight,
        CalculationOverlay,
        WalletIcon
      },
  data() {
    return {
      loader: undefined,
      queryType: 'S',
      queryTypeSelects: [
        {value: 'EF', text: 'Einzelauftrag, fertig und nicht abgerechnet'},
        {value: 'K', text: 'Konto mit Leistung von/bis'},
        {value: 'KM', text: 'Konto mit Leistung im Monat'},
        {value: 'S', text: 'Stammauftrag mit Leistung von/bis'},
        {value: 'SM', text: 'Stammauftrag mit Leistung im Monat'},
        {value: 'EO', text: 'Einzelauftrag offen'},
      ],
      includeEinzel: 'false',
      einzelSelects: [
        {value: 'true', text: 'Einzelaufträge anzeigen'},
        {value: 'false', text: 'Einzelaufträge ausblenden'},
      ],
      hasTill: true,
      hasFrom: true,
      till: LuxonDateTime.local().endOf('month').plus({ hours: -6 }).toISO(),
      from: LuxonDateTime.local().startOf('month').plus({ hours: 6 }).toISO(),
      currentMonth: LuxonDateTime.local().toISO(),
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, maxTime: LuxonDateTime.local().toISO()},
      firstRequest: false,
      selected: {
        id: "",
        object: "",
        auf_name: "",
        price_sum: 0.0,
        positions: [],
      },
      selectedTasks: [],
      currentTasks: [],
      selectedKey: {},
      expandedKeys: {},
      treeNodes: [],
      positions: [],
      taskFields: [
        { key: 'icon', label: '', thStyle: { width: '40px' } },
        { key: 'id', label: 'Nummer', thStyle: { width: '40px' } },
        { key: 'name', label: 'Auftrag', formatter: (value, key, item) => {
          return item.object + " - " + item.auf_name
          }
          },
        { key: 'price_arbl', tdClass: 'text-right', label: 'Arbeitsleistung', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_fahr', tdClass: 'text-right', label: 'Fahrzeuge', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_ei_ma', tdClass: 'text-right', label: 'Eigenmaterial', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_fr_ma', tdClass: 'text-right', label: 'Fremdmaterial', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_sum', tdClass: 'text-right', label: 'Gesamtpreis', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
      ],
      kontoFields: [
        { key: 'icon', label: '', thStyle: { width: '40px' } },
        { key: 'hh_aus_txt', label: 'Ausgabekonto'},
        { key: 'hh_ein_txt', label: 'Einnahmekonto'},
        { key: 'price_arbl', tdClass: 'text-right', label: 'Arbeitsleistung', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_fahr', tdClass: 'text-right', label: 'Fahrzeuge', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_ei_ma', tdClass: 'text-right', label: 'Eigenmaterial', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_fr_ma', tdClass: 'text-right', label: 'Fremdmaterial', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
        { key: 'price_sum', tdClass: 'text-right', label: 'Gesamtpreis', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
      ],
      positionFields: [
        { key: 'gi_legr', label: '', thStyle: { width: '40px' } },
        { key: 'pos_text', label: 'Auftrag', formatter: (value, key, item) => {
          return item.pos_text ? item.pos_text : item.legr_txt;
          }
          },
        { key: 'dat_leist', label: 'Datum', formatter: (value) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return event.toLocaleDateString('de-DE', options);
          }},
        { key: 'gi_leist', label: 'Position'},
        { key: 'menge', label: 'Umfang', tdClass: 'text-right', formatter: (value, key, item) => {
            let a = value.toFixed(2);
            a = a.replace(".", ",");
            return a + " " + item.me;
          }},
        { key: 'g_preis', label: 'Preis', tdClass: 'text-right', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
      ],
      hhs: [],
      selectedHh: 'NONE',
      useHh: false,
      definition: null,
    }
  },
  created() {
    this.queryData()
  },
  watch: {
    till: function(newVal, oldVal) {
      if (this.firstRequest) {
      this.queryData();
      }
    },
    from: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    hasFrom: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    hasTill: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    includeEinzel: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    currentMonth: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    queryType: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    selectedHh: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
  },
  computed: {
    defaultMonth() {
      return LuxonDateTime.fromISO(this.currentMonth).month;
    },
    defaultYear() {
      return LuxonDateTime.fromISO(this.currentMonth).year;
    }
  },
  methods: {
    generatePreview(id) {
      let task = this.currentTasks[0];
      let positions = this.selected.positions;
      let taskEntries = [];
      for (let i = 0; i < positions.length; i++) {
        taskEntries.push(positions[i].id);
      }
      let req = {
        "data": {
          "invoiceNumber": "test/234",
          "intakeAccount": task.hh_ein,
          "outtakeAccount": task.hh_aus,
          "tasks": [
            {
              "id": task.id,
              "taskEntries": taskEntries
            }
          ]
        },
        "resultFileType": "Pdf",
        "templateNames": [
          "sammel_summen"
        ],
        "customerNumber": "8888810",
        "aesKey": "8yhv7aYXbFNES9LpQbboaiAs4QPGqvypZwEXVNyw3Jw="
      }

      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/preview',
          req
      ).then((response) => {
        if (response.status === 200 ) {
          const byteCharacters = atob(response.body);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const file = new Blob([byteArray], {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          console.log(response);
        }
      }, (response) => {
        console.log(response);
      });
    },
    openPreview() {
      let items = [];
      if (this.selected.id) {
        items.push({
          task: this.currentTasks[0],
          data: this.selected,
          finished: false,
          rnr: "Vorschau",
        })
      } else {
        for (let i = 0; i < this.selectedTasks.length; i++) {
          items.push({
            task: this.currentTasks[i],
            data: this.selectedTasks[i],
            finished: false,
            rnr: "Vorschau",
          })
        }
      }
      this.$refs.calculationOverlay.showDialog(items, this.queryType === "K" || this.queryType === "KM", this.definition);
    },
    move(direction) {
      let date = LuxonDateTime.fromISO(this.currentMonth);
      date = date.plus({months: direction});
      this.currentMonth = date.toISO();
    },
    monthPickerChanged({monthIndex, year}) {
      let yearDiff = year - this.defaultYear;
      let monthDiff = monthIndex - this.defaultMonth;
      let date = LuxonDateTime.fromISO(this.currentMonth);
      date = date.plus({years: yearDiff, months: monthDiff});
      this.currentMonth = date.toISO();
    },
    getGesPreis() {
      let a = this.selected.price_sum.toFixed(2) + ' €';
      return a.replace(".", ",");
    },
    selectionChanged(e) {
      // wait for next tick to have updated selectedKey
      this.$nextTick(() => {
        this.currentTasks = [];
        const keys = this.calculateKeys(this.treeNodes);
        if (keys.length === 0) {
          this.selected = {
            id: "",
            object: "",
            auf_name: "",
            price_sum: 0.0,
            positions: [],
          };
          this.selectedTasks = [];
          this.currentTasks = [];
        } else if (keys.length === 1) {
          const key = keys[0];
          this.selected = this.positions[key];
          this.selectedTasks = [];
        } else {
          this.selected = {
            id: "",
            object: "",
            auf_name: "",
            price_sum: 0.0,
            positions: [],
          };
          let temp = [];
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            temp.push(this.positions[key]);
          }
          this.selectedTasks = temp;
        }
        console.log(this.selected)
        console.log(this.selectedTasks)
      });
    },
    showLoader() {
      if (this.loader === undefined)
      this.loader = this.$loading.show();

    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    queryData() {
      this.showLoader();
      let urlPart = '';
      if (this.queryType === 'S') {
        urlPart = 'auftrag?include_einzel=' + this.includeEinzel + (this.hasFrom ? "&from=" + this.from.split('T')[0] : "") + (this.hasTill ? "&till=" + this.till.split('T')[0] : "");
      } else if (this.queryType === 'SM') {
        urlPart = 'auftrag?include_einzel=' + this.includeEinzel + "&is_month=true" + "&from=" + this.currentMonth.split('T')[0];
      } else if (this.queryType === 'EF') {
        urlPart = 'einzel/false';
      } else if (this.queryType === 'EO') {
        urlPart = 'einzel/true';
      } else if (this.queryType === 'K') {
        urlPart = 'konto?in_konto=' + encodeURIComponent((this.useHh ? this.selectedHh : '')) + (this.hasFrom ? "&from=" + this.from.split('T')[0] : "") + (this.hasTill ? "&till=" + this.till.split('T')[0] : "");
      } else if (this.queryType === 'KM') {
        urlPart = 'konto?in_konto=' + encodeURIComponent((this.useHh ? this.selectedHh : '')) + "&is_month=true" + "&from=" + this.currentMonth.split('T')[0];
      }
      this.$http.get(
          Server_URL+'/auftragsbuch/calculation/'+urlPart,
      ).then(this.responseOkGet, this.responseError)
    },
    async responseOkGet(response) {
      this.hideLoader();
      this.firstRequest = true;
      if (response.status === 200 ) {
        this.selected = {
          id: "",
          object: "",
          auf_name: "",
          price_sum: 0.0,
          positions: [],
        };
        this.selectedTasks = [];
        this.selectedKey =  {};
        console.log(response);
        this.treeNodes = response.body.structure;
        this.definition = response.body.invoice_definition;
        this.positions = await decryptPositions(sessionStorage.getItem("aes"), response.body.positions);
        if (response.body.hhs && response.body.hhs.length) {
            this.hhs = response.body.hhs;
            console.log(this.hhs)
        }
        console.log(this.positions)
      } else {
        //window.location = Redirect_500;
        console.log(response);
      }
    },
    responseError(response) {
      this.hideLoader();
      console.log(response);
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
    calculateKeys(data = []) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (this.selectedKey[data[i].key] === true) {
          if (data[i].children && data[i].children.length > 0) {
            res = res.concat(this.collectKeys(data[i].children));
          } else {
            res.push(data[i].key);
            this.currentTasks.push(data[i]);
          }
        } else if (data[i].children && data[i].children.length > 0) {
          res = res.concat(this.calculateKeys(data[i].children));
        }
      }
      return res;
    },
    collectKeys(data = []) {
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].children && data[i].children.length > 0) {
          res = res.concat(this.collectKeys(data[i].children));
        } else {
          res.push(data[i].key);
          this.currentTasks.push(data[i]);
        }
      }
      return res;
    }
  }
}
</script>

<style>
.custom-icon > .material-design-icon__svg {
  bottom: 0 !important;
}

.custom-icon-size > .material-design-icon__svg {
  width: 1rem !important;
  height: 1rem !important;
  bottom: 0.3rem !important;
  left: 1rem;
}

.shift-left .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
  width: 0px !important;
}

.vld-overlay {
  z-index: 1051 !important;
}

</style>

<style scoped>
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}

::v-deep .custom-select {
  color: black;
}



::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  color: black;
  font-weight: 400;
  border: 1px solid #c0c0c0;
  width: 100%;
  height: 26px;
}

::v-deep .month-picker-input-container {
  height: 26px;
  margin-top: 0.5rem;
  width: 60%;
}

::v-deep .month-picker__container {
  z-index: 100;
}

</style>
